import axios, { AxiosInstance } from 'axios';
import { browserHistory } from 'router/Routes';
import { baseApiUrl } from '../constants';
import { getJwtToken, setJwtToken } from './jwt';

const service: AxiosInstance = axios.create({ baseURL: baseApiUrl });

service.interceptors.request.use(
    (config) => {
        const token = getJwtToken();
        const permString = localStorage.getItem('permissions');
        const permissions = permString ? JSON.parse(permString) : [];
        const language = localStorage.i18nextLng;
        if (token !== undefined && token !== '' && token !== 'undefined') {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        if (permissions && permissions.length > 0) {
            config.headers['x-current-role'] = permissions[0];
        }

        config.headers['Accept-Language'] = language ? language.slice(0, 2) : 'ru';

        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const status = error?.response?.status;
        if (status && status === 401) {
            browserHistory.push('/login');
            setJwtToken('');
            localStorage.removeItem('permissions');
        }

        return Promise.reject(error);
    }
);

export default service;
